import FormMessage from "../models/FormMessage";

const FormMessageStore = FormMessage.create();

export default FormMessageStore;
